import { render } from "./Analysis.vue?vue&type=template&id=0c70ba3c&scoped=true&ts=true"
import script from "./Analysis.vue?vue&type=script&lang=ts"
export * from "./Analysis.vue?vue&type=script&lang=ts"

import "./Analysis.vue?vue&type=style&index=0&id=0c70ba3c&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c70ba3c"]])

export default __exports__